import { render, staticRenderFns } from "./InsuranceDocumentViewer.vue?vue&type=template&id=13f78674&scoped=true"
import script from "./InsuranceDocumentViewer.vue?vue&type=script&lang=js"
export * from "./InsuranceDocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./InsuranceDocumentViewer.vue?vue&type=style&index=0&id=13f78674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f78674",
  null
  
)

export default component.exports